// @flow
import { RESORT_RECOMMENDATIONS } from 'Client/cms/toolkit/constants';
import { addTranslationKeys } from 'Src/i18n';
import * as configQueries from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import resortThumbnailQuery from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import { isSeller } from 'Utils/seller/sellerUtils';
import { LINE_PRODUCT_RECOMMENDATIONS } from 'Utils/request/requestDictionary';

type CMSProps = {
  resortId: string,
};

export const productRecommendationsResolver = {
  name: RESORT_RECOMMENDATIONS,
  resolve(appContext: AppContext, props: CMSProps) {
    if (isSeller(appContext)) {
      return Promise.resolve();
    }

    const { cmsContent = '', cmsRelease = '' } = appContext;
    const cmsArgs = `content: "${cmsContent}", release: "${cmsRelease}"`;
    const { resortId } = props;
    const resortThumbnailQueryString = resortThumbnailQuery({
      content: cmsContent,
      release: cmsRelease,
    });
    const query = `query {
      recommendations(productId: "${resortId}", limit: 3) {
        products: resorts {
          ${resortThumbnailQueryString}
        }
      },
      config(${cmsArgs}) {
        common {
          next
          previous
          close
          thumbnailCTA
          thumbnailTourCTA
          recommendedResorts
        }
        ${configQueries.price()}
        ${configQueries.resort(appContext)}
      }
    }`;
    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_PRODUCT_RECOMMENDATIONS,
        strictErrors: false,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      });
  },
};
